import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardLayout from "./components/DashboardLayout";
import OrganizationBillingGate from "./components/OrganizationBillingGate";
import Login from "./pages/Login";
import Signups from "./pages/Signups";
import Revenue from "./pages/Revenue";
import Schools from "./pages/Schools";
import Courses from "./pages/Courses";
import Organizations from "./pages/Organizations";
import Creators from "./pages/Creators";
import TrackPDF from "./pages/TrackPDF";
import OrgDashboard from "./pages/OrgDashboard";
import Members from "./pages/Members";
import Team from "./pages/Team";
import Billing from "./pages/Billing";
import StudyLocations from "./pages/StudyLocations";
import StudyHours from "./pages/StudyHours";
import MemberRequests from "./pages/MemberRequests";
import Grades from "./pages/Grades";
import "./App.css";
import "./firebase"; // Initialize Firebase

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/track-pdf/:trackingId" element={<TrackPDF />} />

          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute requireSyllySyncAdmin={true}>
                <DashboardLayout>
                  <Routes>
                    <Route path="signups" element={<Signups />} />
                    <Route path="revenue" element={<Revenue />} />
                    <Route path="schools" element={<Schools />} />
                    <Route path="courses" element={<Courses />} />
                    <Route path="organizations" element={<Organizations />} />
                    <Route path="creators" element={<Creators />} />
                    <Route
                      path="/"
                      element={<Navigate to="/dashboard/signups" replace />}
                    />
                  </Routes>
                </DashboardLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/org-dashboard/*"
            element={
              <ProtectedRoute requireOrgAdmin={true}>
                <DashboardLayout>
                  <Routes>
                    <Route path="signups" element={<OrgDashboard />} />
                    <Route path="members" element={<OrganizationBillingGate><Members /></OrganizationBillingGate>} />
                    <Route path="team" element={<OrganizationBillingGate><Team /></OrganizationBillingGate>} />
                    <Route path="billing" element={<Billing />} />
                    <Route path="study-locations" element={<StudyLocations />} />
                    <Route path="study-hours" element={<StudyHours />} />
                    <Route path="member-requests" element={<OrganizationBillingGate><MemberRequests /></OrganizationBillingGate>} />
                    <Route path="grades" element={<Grades />} />
                    <Route
                      path="/"
                      element={<Navigate to="/org-dashboard/grades" replace />}
                    />
                  </Routes>
                </DashboardLayout>
              </ProtectedRoute>
            }
          />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
